module.exports = __webpack_public_path__ + "static/media/mastertemp.509de802.pdf";